import { useCallback, useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { getUnreadCommentsIntersectionObserver } from '../UnreadCommentsIntersectionObserver';
import { useUnreadCommentsActions } from './useUnreadComments';
import { useDebouncedMarkCommentsAsRead } from './useDebouncedMarkCommentsAsRead';

const MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
export const useUnreadCommentsObserverSetup = ({ pageId }: { pageId: string | undefined }) => {
	const { updateUnreadCommentIDSet } = useUnreadCommentsActions();

	const { debouncedMarkCommentsAsRead, flushPendingComments } = useDebouncedMarkCommentsAsRead(
		MARK_COMMENTS_AS_READ_DEBOUNCE_MS,
	);

	const intersectionCallback = useCallback(
		(commentId: string) => {
			if (commentId) {
				updateUnreadCommentIDSet(new Set([commentId]), 'remove');
				debouncedMarkCommentsAsRead(commentId);
			}
		},
		[updateUnreadCommentIDSet, debouncedMarkCommentsAsRead],
	);

	useEffect(() => {
		if (!fg('confluence_frontend_unread_comments_fixes') || !pageId) {
			return;
		}

		const observer = getUnreadCommentsIntersectionObserver();

		observer.registerIntersectionCallback(intersectionCallback);

		return () => {
			observer.disconnect();
			flushPendingComments();
		};
	}, [intersectionCallback, pageId, flushPendingComments]);
};
